/*
 * fn: removeMediavineAdboxes
 *
 * Removes MediaVine ad boxes for when ads are disabled
 *
 */
export const removeMediavineAdboxes = () => document.querySelectorAll('.mv-ad-box').forEach((el) => el.remove())
